import InventoryBody from "../features/inventory/InventoryBody"

const InventoryBodyPage = () => {
    return (
        <InventoryBody />
    )
}

export default InventoryBodyPage